// @ts-check
import Vue from 'vue';

// @ts-ignore
import template from './template.html';
import './styles.scss';

export default Vue.component('bc-example', {
  template,
});



// WEBPACK FOOTER //
// ./src/components/bc-example/index.js